import { render, staticRenderFns } from "./configPop.vue?vue&type=template&id=e95e1fbc&scoped=true"
import script from "./configPop.vue?vue&type=script&lang=js"
export * from "./configPop.vue?vue&type=script&lang=js"
import style0 from "./configPop.vue?vue&type=style&index=0&id=e95e1fbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95e1fbc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConjoinedGoodsBasicCard: require('/drone/src/components/ConjoinedGoods/basicCard.vue').default,ConjoinedGoodsPriceConfirmPop: require('/drone/src/components/ConjoinedGoods/priceConfirmPop.vue').default,ConjoinedGoodsCancelConfirmPop: require('/drone/src/components/ConjoinedGoods/cancelConfirmPop.vue').default,ConjoinedGoodsChoosePop: require('/drone/src/components/ConjoinedGoods/choosePop.vue').default})
